import { render, staticRenderFns } from "./notice_manage.vue?vue&type=template&id=2dad278d"
import script from "./notice_manage.vue?vue&type=script&lang=js"
export * from "./notice_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dad278d')) {
      api.createRecord('2dad278d', component.options)
    } else {
      api.reload('2dad278d', component.options)
    }
    module.hot.accept("./notice_manage.vue?vue&type=template&id=2dad278d", function () {
      api.rerender('2dad278d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/customer_interaction/notice_manage/notice_manage.vue"
export default component.exports